<template lang="pug">
.target-other-user-detail-modal
  b-modal(v-model="_value" size="xl" @ok="ok" no-close-on-backdrop no-close-on-esc)
    template(#modal-header="{ ok }")
      .option-target-other-user-list-modal-header
        .d-flex.justify-content-start.align-items-center
          .d-flex.justify-content-start
            span.menu-title 宛先一覧
          .d-flex.justify-content-end.flex-fill
            button.btn(@click="onDownload" type="button") ダウンロード
      button.close(type="button" @click="ok") ×

    .option-target-other-user-list-modal-body
      TargetOtherUserDetailTable(v-model="_items" :fields="fields")

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import TargetOtherUserDetailTable, { TargetOtherUserDetailTableField, TargetOtherUserDetailTableItem } from "@/pc/containers/sendDocuments/TargetOtherUserDetailTable.vue";

/**
 * ### 文書送付、確認・同意ユーザー一覧モーダル
 */
@Component({
  components: {
    TargetOtherUserDetailTable
  }
})
export default class TargetOtherUserDetailModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** テーブル行情報 */
  @Prop({ required: true })
  items!: Array<TargetOtherUserDetailTableItem>;
  /** 文書送付タイトル */
  @Prop()
  title!: string;

  /** テーブル列情報 */
  fields: Array<TargetOtherUserDetailTableField> = [];

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _items(): Array<TargetOtherUserDetailTableItem> {
    return this.items;
  }

  set _items(newValue: Array<TargetOtherUserDetailTableItem>) {
    this.$emit("update:items", newValue);
    return;
  }

  /**
   * ### vue lifesycle mounted
   */
  public mounted(): void {
    let fields: Array<TargetOtherUserDetailTableField> = this.createFields();
    this.fields = fields;

    return;
  }

  /**
   * ### 列名を作成する
   */
  public createFields(): Array<TargetOtherUserDetailTableField> {
    let fields: Array<TargetOtherUserDetailTableField> = [];

    fields.push({ key: "groupName", label: "グループ名（種類名）", sortable: false, sortDirection: "desc", class: "group-name" });
    fields.push({ key: "memberName", label: "メンバー名（所属）", sortable: false, sortDirection: "desc", class: "member-name" });
    fields.push({ key: "memberTel", label: "電話番号", sortable: false, sortDirection: "desc", class: "member-tel" });

    return fields;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  /**
   * ### 回答結果をCSVダウンロードする
   */
  public onDownload(): void {
    const csvTitle: string = this.createCsvTitle();
    const csvData: string = this.createCsvLines(this.items);
    const fileName: string = `HitomeQコネクト-文書送付-${this.title}-宛先一覧.csv`;
    this.downloadCsv(csvTitle + csvData, fileName);
    return;
  }

  /**
   * ### CSVの1行目(列名)を作成する
   *
   * - BOM付きで出力させるために`\ufeff`を先頭に付与
   * - 末尾に改行コードを付与する
   */
  public createCsvTitle(): string {
    let columns: string[] = [];
    columns.push("グループ名（種類名）");
    columns.push("メンバー名（所属）");
    columns.push("電話番号");
    return "\ufeff" + columns.join(",") + "\n";
  }

  /**
   * ### CSV出力する行情報を作成する
   */
  public createCsvLines(items: Array<TargetOtherUserDetailTableItem>): string {
    let csvLines: string[] = []; // 全行情報
    for (const item of items) {
      let csvLine: string[] = [];
      csvLine.push(`${item.name}（${item.groupTypeName}）`);
      csvLine.push(`${item.memberName}（${item.memberOrganization}）`);
      csvLine.push(`="${item.memberTel}"`);
      csvLines.push(csvLine.join(","));
    }
    return csvLines.join("\n");
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    return;
  }
}
</script>
